import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/star_stroke",
    clipPath: "url(#clip_StarStroke)"
  }, React.createElement("path", {
    id: "Star 1",
    d: "M8.61314 1.419C8.39329 0.860334 7.6067 0.860334 7.38686 1.419L5.94981 5.07078C5.8577 5.30487 5.64161 5.46629 5.39206 5.48744L1.60491 5.80834C1.0296 5.85708 0.790023 6.57288 1.21902 6.96128L4.15212 9.61684C4.32953 9.77746 4.40669 10.0219 4.35387 10.256L3.46636 14.1885C3.33579 14.767 3.96912 15.2134 4.4657 14.8928L7.64369 12.8412C7.86077 12.701 8.13923 12.701 8.35631 12.8412L11.5343 14.8928C12.0309 15.2134 12.6642 14.767 12.5336 14.1885L11.6461 10.256C11.5933 10.0219 11.6705 9.77746 11.8479 9.61684L14.781 6.96128C15.21 6.57288 14.9704 5.85708 14.3951 5.80834L10.6079 5.48744C10.3584 5.46629 10.1423 5.30487 10.0502 5.07078L8.61314 1.419Z",
    stroke: "currentColor",
    strokeWidth: "2"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0"
  }, React.createElement("rect", {
    width: "16",
    height: "16",
    fill: "white"
  }))));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { StarStroke16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var StarStroke16 = createIcon(IconComponent);